// extracted by mini-css-extract-plugin
export default {"PriceList":"PriceList_PriceList__RotX5","PriceList__new":"PriceList_PriceList__new__R6ZEZ","PriceList__table":"PriceList_PriceList__table__U9igf"};